module.exports = __webpack_public_path__ + "static/media/lock.2ab47ba9.svg";